exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".submit-dialog{text-align:center;margin:1rem 0 0}.order-list__dropdown-menu .el-button{width:100%;display:block}.order-list__drawer .drawer__content{width:430px}.order-list__red-btn{background:red!important;border-color:red!important}.order-list__red-btn:hover{opacity:.6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e5cddf0","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/staff/blocks/OrderList.vue
// module id = 486
// module chunks = 0